<template>
    <div class="main main-padding">
        <!-- 各产品统计 -->
        <Row :gutter="10" style="margin-top:10px">
                <Row :gutter="10" class="card-item">
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                        <infor-card
                            id-name="userCount"
                            :end-val="baseData.userCount"
                            iconType="ios-contacts"
                            color="linear-gradient(-60deg,rgba(116,146,241,1),rgba(97,119,237,1))"
                            intro-text="产品总用户数"
                            textColor="#60c0dd"
                            iconCustom="i-icon-user"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('screenMain')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="screenUserCount"
                            :end-val="baseData.screenUserCount"
                            iconType="md-laptop"
                            color="linear-gradient(-60deg,rgba(89,170,255,1),rgba(59,153,252,1))"
                            intro-text="大屏总用户数"
                            textColor="#60c0dd"
                            iconCustom="i-icon-screen"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('moveTeaMain')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="moveTeaCount"
                            :end-val="baseData.moveTeaCount"
                            iconType="md-phone-portrait"
                            color="linear-gradient(-34deg,rgba(32,153,255,1),rgba(103,188,227,1))"
                            intro-text="移动授课总用户数"
                            textColor="#60c0dd"
                            iconCustom="i-icon-mobile"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('prepareMain')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="assistantCount"
                            :end-val="baseData.assistantCount"
                            iconType="md-bookmarks"
                            color="linear-gradient(-34deg,rgba(15,170,221,1),rgba(27,226,231,1))"
                            intro-text="备课助手总用户数"
                            textColor="#60c0dd"
                            iconCustom="i-icon-pre"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('intelligentMain')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="intelligentCount"
                            :end-val="baseData.intelligentCount"
                            iconType="logo-youtube"
                            color="linear-gradient(-34deg,rgba(4,228,198,1),rgba(4,206,179,1))"
                            intro-text="智能PC总用户数"
                            textColor="#60c0dd"
                            iconCustom="i-icon-pc"
                        ></infor-card>
                    </Col>
                </Row>
                <Row :gutter="10" style="margin-top:10px" class="card-item">
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('activeUserNum')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="activeUserNum"
                            :end-val="baseData.activeUserNum"
                            iconType="ios-people"
                            color="#39C6E9"
                            intro-text="活跃用户数"
                            textColor="#60c0dd"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('homeworkMain')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="homeworkNum"
                            :end-val="baseData.homeworkNum"
                            iconType="ios-book"
                            color="linear-gradient(-34deg,rgba(252,149,1,1),rgba(254,174,1,1))"
                            intro-text="作业总用户数"
                            textColor="#60c0dd"
                            iconCustom="i-icon-hw"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" @click.native="lookProInfoByRouter('studentMain')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="studentCount"
                            :end-val="baseData.studentCount"
                            iconType="md-phone-landscape"
                            color="#39C6E9"
                            intro-text="学生机总数"
                            textColor="#60c0dd"
                        ></infor-card>
                    </Col>
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6"
                         @click.native="lookProInfoByRouter('cloudBoardStatic')">
                        <infor-card
                            style="cursor: pointer;"
                            id-name="cloudBoard"
                            :end-val="baseData.cloudBoard"
                            iconType="ios-cloud-circle"
                            color="#39C6E9"
                            intro-text="云白板总数"
                            textColor="#60c0dd"
                        ></infor-card>
                    </Col>
                    <!-- @click.native="lookProInfoByRouter('conservationCount')"  style="cursor: pointer;"-->
                    <Col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                        <infor-card
                            id-name="conserCounts"
                            :end-val="baseData.conserCounts"
                            iconType="ios-chatbubbles"
                            color="#39C6E9"
                            intro-text="总会话次数"
                            textColor="#60c0dd"
                        ></infor-card>
                    </Col>
                </Row>
            <!--</Col>-->
        </Row>
        <!-- 最近30天日活跃用户数-分产品 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <day-active-num></day-active-num>
            </Col>
        </Row>
        <!-- 各产品累计用户数每日趋势 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <day-trend></day-trend>
            </Col>
        </Row>
        <!-- 总产品使用次数Top10用户、 总产品使用天数top10学校 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'总产品使用次数Top10用户'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pro_use_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="proUseTop"
                ></histogram-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'总产品使用天数top10学校'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'pro_school_top'"
                    :height="'360px'"
                    :histogramTooltip="'useDay'"
                    ref="schoolUseTop"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  总产品使用次数Top20学科 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="' 总产品使用次数Top10学科'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pro_subject_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="subjectUseTop"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>

<script>
    import inforCard from "../../components/inforCard.vue";//数据卡片
    import dayActiveNum from "./modules/dayActiveNum.vue";//最近30天日活跃用户数-分产品
    import dayTrend from "./modules/dayTrend.vue";//各产品累计用户数每日趋势
    import HistogramCharts from "../../components/charts/HistogramCharts.vue";//柱状图
    import {findUserCount,getConversationCount, findTopTea,findTopSch,findSubjectUsed} from "../../service/api.js";

    export default {
        name: "pro-board-main",
        data () {
            return {
                baseData: {
                    userCount: 0,//产品总用户数
                    screenUserCount: 0,//大屏总用户数
                    assistantCount: 0,//备课助手总用户数
                    intelligentCount: 0,//智能PC总用户数
                    homeworkNum: 0,//作业总用户数
                    moveTeaCount: 0,//移动授课总用户数
                    studentCount: 0,//学生机总数
                    activeUserNum: 0,//活跃用户数
                    cloudBoard: 0,//云白板总数
                    conserCounts:0//总会话次数
                }
            };
        },
        components: {
            inforCard,//数据卡片
            dayActiveNum,// 最近30天日活跃用户数-分产品
            dayTrend,// 各产品累计用户数每日趋势
            HistogramCharts//柱状图组件
        },
        methods: {
            /**
             * 查看大屏统计详情
             */
            lookProInfoByRouter (name) {
                let routeData = this.$router.resolve({name: name});
                window.open(routeData.href, '_blank');
            },
            /**
             * 获取产品用户总数
             */
            async getUserCount () {
                let _this = this;
                await findUserCount()
                    .then(function (data) {
                        _this.baseData.userCount = data.allCount;//获取产品总用户数
                        _this.baseData.screenUserCount = data.screenCount;//获取大屏总用户数
                        _this.baseData.moveTeaCount = data.mobileCount;//获取移动授课总用户数
                        _this.baseData.assistantCount = data.BKCount;//获取备课助手总用户数
                        _this.baseData.intelligentCount = data.PCCount;//获取智能PC总用户数
                        _this.baseData.homeworkNum = data.homeworkCount;//获取作业总用户数
                        _this.baseData.studentCount = data.studentMachineCount; // 学生端用户数
                        _this.baseData.activeUserNum = data.userCount; // 活跃用户数
                        _this.baseData.cloudBoard = data.whiteboardCount; // 云白板总数
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取总会话次数
             */
            async queryConversationCount () {
                let _this = this;
                await getConversationCount()
                    .then(function (data) {
                        _this.baseData.conserCounts = data;//获取总会话次数
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取总产品使用次数Top10用户
             */
            async getTopTea () {
                let _this = this;
                await findTopTea()
                    .then(function (data) {
                        let usersList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        for (let i = 0; i < usersList.length; i++) {
                            xDataArr.push(usersList[i].name);
                            seriesDataArr.push(usersList[i].useridcount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.proUseTop.initDataSource(usersList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取活跃学校排名
             */
            async getTopSch () {
                let _this = this;
                await findTopSch()
                    .then(function (data) {
                        let schoolList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        for (let i = 0; i < schoolList.length; i++) {
                            xDataArr.push(schoolList[i].schoolName);
                            seriesDataArr.push(schoolList[i].SCHOOLidcount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.schoolUseTop.initDataSource(schoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取总产品使用次数Top20学科
             */
            async getSubjectUsed () {
                let _this = this;
                await findSubjectUsed()
                    .then(function (data) {
                        let subjectList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        var displayName = "";
                        for (let i = 0; i < subjectList.length; i++) {
                            displayName = subjectList[i].sub_name;
                            xDataArr.push(
                                displayName.length > 5
                                    ? displayName.substring(0, 5) + "..."
                                    : displayName
                            );
                            seriesDataArr.push(subjectList[i].usercount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.subjectUseTop.initDataSource(subjectList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "各产品使用统计");
            // 获取产品用户总数
            this.getUserCount();
            // 获取总会话次数
            this.queryConversationCount();
            // 获取总产品使用次数Top10用户
            this.getTopTea();
            // 获取总产品使用天数top10学校
            this.getTopSch();
            // 获取总产品使用次数Top20学科
            this.getSubjectUsed();
        }
    };
</script>


<style lang="scss" scoped>
    @import "../../style/home";
</style>
<style lang="scss">
    .i-icon-user {
        width: 58px;
        height: 38px;
        background-image: url("../../assets/images/user-icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .i-icon-screen {
        width: 53px;
        height: 48px;
        background-image: url("../../assets/images/screen-icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .i-icon-mobile {
        width: 34px;
        height: 63px;
        background-image: url("../../assets/images/mobile-icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .i-icon-pre {
        width: 41px;
        height: 62px;
        background-image: url("../../assets/images/pre-icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .i-icon-pc {
        width: 70px;
        height: 44px;
        background-image: url("../../assets/images/pc-icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .i-icon-hw {
        width: 57px;
        height: 54px;
        background-image: url("../../assets/images/hw-icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .card-item{
        .ivu-col-span-xl-6 {
            display: block;
            width: 20%;
        }
    }
    .ivu-card-head{
        text-align: left;
    }

</style>
